import { render, staticRenderFns } from "./FormulaSettings.vue?vue&type=template&id=093e166e&lang=pug"
import script from "./FormulaSettings.vue?vue&type=script&lang=js"
export * from "./FormulaSettings.vue?vue&type=script&lang=js"
import style0 from "./FormulaSettings.vue?vue&type=style&index=0&id=093e166e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports